// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { useLayoutEffect, useRef, useState } from 'react';
import styles from './CompressionDeliveryContent.module.scss';
import _debounce from 'lodash/debounce';
import { nonNull } from 'util/commons';
import { useTranslation } from 'react-i18next';

type Props = {
  contents: React.ReactNode;
  id?: string;
};

export const CompressionDeliveryContent = (props: Props) => {
  const [height, setHeight] = useState<number>();
  const ref = useRef<HTMLDivElement>(null);
  const { i18n } = useTranslation();

  useLayoutEffect(() => {
    if (!props.id) {
      return;
    }

    /**
     * Workaround to make layout does not break when contents have multiple lines in src/components/organisms/CompressionDelivery/index.tsx.
     * The idea is to calculate the height of the content dynamically and set the minHeight of the label to match it.
     * But it has problems with performance and flickering when resizing the window.
     *
     * Please fix src/components/organisms/CompressionDelivery/index.tsx
     * This component has f**king stupid usage, anyone who wrote that should be fired immediately.
     */
    const handleCalculateHeight = () => {
      const element = document.getElementById(nonNull(props.id));

      if (element && ref.current) {
        element.style.minHeight = '0px';
        setHeight(undefined);

        _debounce(() => {
          const targetHeight = element.getBoundingClientRect().height;
          const currentHeight = nonNull(ref.current).getBoundingClientRect()
            .height;

          if (targetHeight > currentHeight) {
            setHeight(targetHeight);
          } else {
            element.style.minHeight = `${currentHeight}px`;
          }
        }, 50)();
      }
    };

    handleCalculateHeight();

    const debouncedHandleCalculateHeight = _debounce(handleCalculateHeight, 50);
    window.addEventListener('resize', debouncedHandleCalculateHeight);

    return () => {
      window.removeEventListener('resize', debouncedHandleCalculateHeight);
    };
  }, [props, i18n.language]);

  return (
    <div className={styles.content} style={{ minHeight: height }} ref={ref}>
      <div>：</div>
      <div>{props.contents}</div>
    </div>
  );
};
